function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), React.createElement("defs", null, React.createElement("path", {
  d: "M22.547 7.267l.098.088c.47.469.472 1.227.006 1.693L16.699 15l5.952 5.952c.435.435.465 1.121.082 1.595l-.088.098c-.469.47-1.227.472-1.693.006L15 16.699l-5.952 5.952a1.193 1.193 0 01-1.595.082l-.098-.088a1.198 1.198 0 01-.006-1.693L13.301 15 7.349 9.048a1.193 1.193 0 01-.082-1.595l.088-.098a1.198 1.198 0 011.693-.006L15 13.301l5.952-5.952a1.193 1.193 0 011.595-.082z",
  id: "path-1"
})), React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#path-1",
  transform: "translate(-7 -7)",
  fillRule: "evenodd"
})));